import { FC } from 'react';
import { Select } from 'antd';
import { IProps } from './type';

const SDropdown: FC<IProps> = (props) => {
  const isMultiple = props.mode === 'multiple';

  return (
    <Select
      id={props.id}
      value={
        isMultiple
          ? (props.value as string[] | number[] | undefined)
          : props.value?.toString() || undefined
      }
      defaultValue={
        isMultiple
          ? (props.value as string[] | number[] | undefined)
          : props.value?.toString() || undefined
      }
      placeholder={props.placeholder}
      mode={props.mode}
      showSearch
      optionFilterProp={isMultiple ? props.optionFilterProp : 'label'}
      className={props.className}
      disabled={props.disabled}
      options={props.options}
      onChange={props.onChange}
    />
  );
};

export default SDropdown;
